/* tslint:disable */
/* eslint-disable */
/**
 * WeighMed Backend APIs - OpenAPI 3.0
 * You can find out more about Swagger at [https://editor.swagger.io/](https://editor.swagger.io/).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VAddTankRequestParams
 */
export interface VAddTankRequestParams {
    /**
     * Name of the tank
     * @type {string}
     * @memberof VAddTankRequestParams
     */
    name: string;
    /**
     * Serial of the tank
     * @type {string}
     * @memberof VAddTankRequestParams
     */
    serial?: string;
    /**
     * Manufacturer of the tank
     * @type {string}
     * @memberof VAddTankRequestParams
     */
    manufacturer?: string;
    /**
     * Model of the tank
     * @type {string}
     * @memberof VAddTankRequestParams
     */
    modelType?: string;
    /**
     * Capacity (L) of the tank
     * @type {number}
     * @memberof VAddTankRequestParams
     */
    capacity?: number;
    /**
     * Empty weight (kg) of the tank
     * @type {number}
     * @memberof VAddTankRequestParams
     */
    minWeight: number;
    /**
     * Full weight (kg) of the tank
     * @type {number}
     * @memberof VAddTankRequestParams
     */
    maxWeight: number;
    /**
     * Minimum evaporation rate (kg/h) of the tank
     * @type {number}
     * @memberof VAddTankRequestParams
     */
    minEvaporationRate: number;
    /**
     * Maximum evaporation rate (kg/h) of the tank
     * @type {number}
     * @memberof VAddTankRequestParams
     */
    maxEvaporationRate: number;
    /**
     * Fast weight loss rate of tank for elevated alarming
     * @type {number}
     * @memberof VAddTankRequestParams
     */
    weightLossFastRate: number;
    /**
     * Critical weight loss rate of tank for elevated alarming
     * @type {number}
     * @memberof VAddTankRequestParams
     */
    weightLossCriticalRate: number;
    /**
     * Apex reset weight (kg) threshold
     * @type {number}
     * @memberof VAddTankRequestParams
     */
    apexResetWeight: number;
    /**
     * Snooze until time for caddy battery low alarm
     * @type {string}
     * @memberof VAddTankRequestParams
     */
    batteryLowSnoozeUntil?: string;
    /**
     * Note for caddy battery low alarm snooze
     * @type {string}
     * @memberof VAddTankRequestParams
     */
    batteryLowSnoozeNote?: string;
    /**
     * Snooze until time for caddy battery critical alarm
     * @type {string}
     * @memberof VAddTankRequestParams
     */
    batteryCriticalSnoozeUntil?: string;
    /**
     * Note for caddy battery critical alarm snooze
     * @type {string}
     * @memberof VAddTankRequestParams
     */
    batteryCriticalSnoozeNote?: string;
    /**
     * Snooze until time for caddy temperature low alarm
     * @type {string}
     * @memberof VAddTankRequestParams
     */
    temperatureLowSnoozeUntil?: string;
    /**
     * Note for caddy temperature low alarm snooze
     * @type {string}
     * @memberof VAddTankRequestParams
     */
    temperatureLowSnoozeNote?: string;
    /**
     * Snooze until time for tank weight low alarm
     * @type {string}
     * @memberof VAddTankRequestParams
     */
    weightLowSnoozeUntil?: string;
    /**
     * Note for tank weight low alarm snooze
     * @type {string}
     * @memberof VAddTankRequestParams
     */
    weightLowSnoozeNote?: string;
    /**
     * Snooze until time for tank weight high alarm
     * @type {string}
     * @memberof VAddTankRequestParams
     */
    weightHighSnoozeUntil?: string;
    /**
     * Note for tank weight high alarm snooze
     * @type {string}
     * @memberof VAddTankRequestParams
     */
    weightHighSnoozeNote?: string;
    /**
     * Snooze until time for tank evaporation rate low alarm
     * @type {string}
     * @memberof VAddTankRequestParams
     */
    evaporationRateLowSnoozeUntil?: string;
    /**
     * Note for tank evaporation rate low alarm snooze
     * @type {string}
     * @memberof VAddTankRequestParams
     */
    evaporationRateLowSnoozeNote?: string;
    /**
     * Snooze until time for tank evaporation rate high alarm
     * @type {string}
     * @memberof VAddTankRequestParams
     */
    evaporationRateHighSnoozeUntil?: string;
    /**
     * Note for tank evaporation rate high alarm snooze
     * @type {string}
     * @memberof VAddTankRequestParams
     */
    evaporationRateHighSnoozeNote?: string;
    /**
     * Snooze until time for weight loss fast alarm
     * @type {string}
     * @memberof VAddTankRequestParams
     */
    weightLossFastSnoozeUntil?: string;
    /**
     * Note for weight loss fast alarm snooze
     * @type {string}
     * @memberof VAddTankRequestParams
     */
    weightLossFastSnoozeNote?: string;
    /**
     * Snooze until time for weight loss critical alarm
     * @type {string}
     * @memberof VAddTankRequestParams
     */
    weightLossCriticalSnoozeUntil?: string;
    /**
     * Note for weight loss critical alarm snooze
     * @type {string}
     * @memberof VAddTankRequestParams
     */
    weightLossCriticalSnoozeNote?: string;
    /**
     * Snooze until time for tank offline alarm
     * @type {string}
     * @memberof VAddTankRequestParams
     */
    offlineSnoozeUntil?: string;
    /**
     * Note for tank offline alarm snooze
     * @type {string}
     * @memberof VAddTankRequestParams
     */
    offlineSnoozeNote?: string;
    /**
     * If current time is less than muteUntilTime, muteCaddy will be set to true in queryConfiguration api
     * @type {string}
     * @memberof VAddTankRequestParams
     */
    muteUntilTime?: string;
    /**
     * Id of clinic the tank belongs to
     * @type {string}
     * @memberof VAddTankRequestParams
     */
    clinicId: string;
    /**
     * Id of caddy the tank is installed
     * @type {string}
     * @memberof VAddTankRequestParams
     */
    caddyId?: string;
    /**
     * Ids of displays
     * @type {Array<string>}
     * @memberof VAddTankRequestParams
     */
    displayIds?: Array<string>;
    /**
     * The tank is active or not
     * @type {boolean}
     * @memberof VAddTankRequestParams
     */
    active: boolean;
}

/**
 * Check if a given object implements the VAddTankRequestParams interface.
 */
export function instanceOfVAddTankRequestParams(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "minWeight" in value;
    isInstance = isInstance && "maxWeight" in value;
    isInstance = isInstance && "minEvaporationRate" in value;
    isInstance = isInstance && "maxEvaporationRate" in value;
    isInstance = isInstance && "weightLossFastRate" in value;
    isInstance = isInstance && "weightLossCriticalRate" in value;
    isInstance = isInstance && "apexResetWeight" in value;
    isInstance = isInstance && "clinicId" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function VAddTankRequestParamsFromJSON(json: any): VAddTankRequestParams {
    return VAddTankRequestParamsFromJSONTyped(json, false);
}

export function VAddTankRequestParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): VAddTankRequestParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'serial': !exists(json, 'serial') ? undefined : json['serial'],
        'manufacturer': !exists(json, 'manufacturer') ? undefined : json['manufacturer'],
        'modelType': !exists(json, 'modelType') ? undefined : json['modelType'],
        'capacity': !exists(json, 'capacity') ? undefined : json['capacity'],
        'minWeight': json['minWeight'],
        'maxWeight': json['maxWeight'],
        'minEvaporationRate': json['minEvaporationRate'],
        'maxEvaporationRate': json['maxEvaporationRate'],
        'weightLossFastRate': json['weightLossFastRate'],
        'weightLossCriticalRate': json['weightLossCriticalRate'],
        'apexResetWeight': json['apexResetWeight'],
        'batteryLowSnoozeUntil': !exists(json, 'batteryLowSnoozeUntil') ? undefined : json['batteryLowSnoozeUntil'],
        'batteryLowSnoozeNote': !exists(json, 'batteryLowSnoozeNote') ? undefined : json['batteryLowSnoozeNote'],
        'batteryCriticalSnoozeUntil': !exists(json, 'batteryCriticalSnoozeUntil') ? undefined : json['batteryCriticalSnoozeUntil'],
        'batteryCriticalSnoozeNote': !exists(json, 'batteryCriticalSnoozeNote') ? undefined : json['batteryCriticalSnoozeNote'],
        'temperatureLowSnoozeUntil': !exists(json, 'temperatureLowSnoozeUntil') ? undefined : json['temperatureLowSnoozeUntil'],
        'temperatureLowSnoozeNote': !exists(json, 'temperatureLowSnoozeNote') ? undefined : json['temperatureLowSnoozeNote'],
        'weightLowSnoozeUntil': !exists(json, 'weightLowSnoozeUntil') ? undefined : json['weightLowSnoozeUntil'],
        'weightLowSnoozeNote': !exists(json, 'weightLowSnoozeNote') ? undefined : json['weightLowSnoozeNote'],
        'weightHighSnoozeUntil': !exists(json, 'weightHighSnoozeUntil') ? undefined : json['weightHighSnoozeUntil'],
        'weightHighSnoozeNote': !exists(json, 'weightHighSnoozeNote') ? undefined : json['weightHighSnoozeNote'],
        'evaporationRateLowSnoozeUntil': !exists(json, 'evaporationRateLowSnoozeUntil') ? undefined : json['evaporationRateLowSnoozeUntil'],
        'evaporationRateLowSnoozeNote': !exists(json, 'evaporationRateLowSnoozeNote') ? undefined : json['evaporationRateLowSnoozeNote'],
        'evaporationRateHighSnoozeUntil': !exists(json, 'evaporationRateHighSnoozeUntil') ? undefined : json['evaporationRateHighSnoozeUntil'],
        'evaporationRateHighSnoozeNote': !exists(json, 'evaporationRateHighSnoozeNote') ? undefined : json['evaporationRateHighSnoozeNote'],
        'weightLossFastSnoozeUntil': !exists(json, 'weightLossFastSnoozeUntil') ? undefined : json['weightLossFastSnoozeUntil'],
        'weightLossFastSnoozeNote': !exists(json, 'weightLossFastSnoozeNote') ? undefined : json['weightLossFastSnoozeNote'],
        'weightLossCriticalSnoozeUntil': !exists(json, 'weightLossCriticalSnoozeUntil') ? undefined : json['weightLossCriticalSnoozeUntil'],
        'weightLossCriticalSnoozeNote': !exists(json, 'weightLossCriticalSnoozeNote') ? undefined : json['weightLossCriticalSnoozeNote'],
        'offlineSnoozeUntil': !exists(json, 'offlineSnoozeUntil') ? undefined : json['offlineSnoozeUntil'],
        'offlineSnoozeNote': !exists(json, 'offlineSnoozeNote') ? undefined : json['offlineSnoozeNote'],
        'muteUntilTime': !exists(json, 'muteUntilTime') ? undefined : json['muteUntilTime'],
        'clinicId': json['clinicId'],
        'caddyId': !exists(json, 'caddyId') ? undefined : json['caddyId'],
        'displayIds': !exists(json, 'displayIds') ? undefined : json['displayIds'],
        'active': json['active'],
    };
}

export function VAddTankRequestParamsToJSON(value?: VAddTankRequestParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'serial': value.serial,
        'manufacturer': value.manufacturer,
        'modelType': value.modelType,
        'capacity': value.capacity,
        'minWeight': value.minWeight,
        'maxWeight': value.maxWeight,
        'minEvaporationRate': value.minEvaporationRate,
        'maxEvaporationRate': value.maxEvaporationRate,
        'weightLossFastRate': value.weightLossFastRate,
        'weightLossCriticalRate': value.weightLossCriticalRate,
        'apexResetWeight': value.apexResetWeight,
        'batteryLowSnoozeUntil': value.batteryLowSnoozeUntil,
        'batteryLowSnoozeNote': value.batteryLowSnoozeNote,
        'batteryCriticalSnoozeUntil': value.batteryCriticalSnoozeUntil,
        'batteryCriticalSnoozeNote': value.batteryCriticalSnoozeNote,
        'temperatureLowSnoozeUntil': value.temperatureLowSnoozeUntil,
        'temperatureLowSnoozeNote': value.temperatureLowSnoozeNote,
        'weightLowSnoozeUntil': value.weightLowSnoozeUntil,
        'weightLowSnoozeNote': value.weightLowSnoozeNote,
        'weightHighSnoozeUntil': value.weightHighSnoozeUntil,
        'weightHighSnoozeNote': value.weightHighSnoozeNote,
        'evaporationRateLowSnoozeUntil': value.evaporationRateLowSnoozeUntil,
        'evaporationRateLowSnoozeNote': value.evaporationRateLowSnoozeNote,
        'evaporationRateHighSnoozeUntil': value.evaporationRateHighSnoozeUntil,
        'evaporationRateHighSnoozeNote': value.evaporationRateHighSnoozeNote,
        'weightLossFastSnoozeUntil': value.weightLossFastSnoozeUntil,
        'weightLossFastSnoozeNote': value.weightLossFastSnoozeNote,
        'weightLossCriticalSnoozeUntil': value.weightLossCriticalSnoozeUntil,
        'weightLossCriticalSnoozeNote': value.weightLossCriticalSnoozeNote,
        'offlineSnoozeUntil': value.offlineSnoozeUntil,
        'offlineSnoozeNote': value.offlineSnoozeNote,
        'muteUntilTime': value.muteUntilTime,
        'clinicId': value.clinicId,
        'caddyId': value.caddyId,
        'displayIds': value.displayIds,
        'active': value.active,
    };
}

